import { useQuery } from '@apollo/client';
import { useClearAccount, useCurrentAccount } from '@application/api';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  MtWishlistGetBookmarksQuery,
  MtWishlistGetBookmarksQueryVariables,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';
import { useMemo } from 'react';
import { useLitterWhereBuilder } from '../../LitterListPageController/api/useLitterWhereBuilder';

export const MT_WISHLIST_GET_BOOKMARKS = graphql(`
  query MtWishlistGetBookmarks(
    $orderBy: BookmarkOrderByWithRelationAndSearchRelevanceInput
    $bookmarksWhere: BookmarkWhereInput!
    $litterCardInfoImgsTake: Int!
    $litterCardInfoTranslationsWhere: LitterTranslationWhereInput!
    $litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput!
  ) {
    accountMe {
      id
      bookmarks(orderBy: $orderBy, where: $bookmarksWhere) {
        id
        litter {
          ...LitterCardInfo
        }
      }
    }
  }
`);

export const useGetBookmarks = () => {
  const { language } = useRouter();
  const { currentAccount } = useCurrentAccount();
  const { litterWhereBuilder } = useLitterWhereBuilder();
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const variables = useMemo((): MtWishlistGetBookmarksQueryVariables => {
    return {
      orderBy: { createdAt: SortOrder.desc },
      bookmarksWhere: {
        litter: { is: litterWhereBuilder() },
      },
      litterCardInfoImgsTake: 1,
      litterCardInfoTranslationsWhere: { language: { equals: language } },
      litterCardInfoBreedTranslationsWhere: { language: { equals: language } },
    };
  }, [language, litterWhereBuilder]);

  const { data, loading, error } = useQuery<
    MtWishlistGetBookmarksQuery,
    MtWishlistGetBookmarksQueryVariables
  >(MT_WISHLIST_GET_BOOKMARKS, {
    variables,
    onError: redirectOnTokenErrorHandler,
    skip: !currentAccount,
    fetchPolicy: 'network-only',
    ssr: false,
  });

  return {
    bookmarks: data?.accountMe?.bookmarks,
    bookmarksLoading: loading,
    bookmarksError: error,
    bookmarkskVariables: variables,
  };
};
